import script from "./UpdateAnswerMessageEmitter.vue?vue&type=script&lang=js"
export * from "./UpdateAnswerMessageEmitter.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__